import React from "react";

import Aux from "../../../hoc/Auxilliary";
import HeaderTop from "../InfoBar";
import NavigationItems from "../NavigationItems";

function index(props) {
  return (
    <Aux>
      <HeaderTop {...props} />
      <NavigationItems />
    </Aux>
  );
}

export default index;
